import React, { ChangeEvent } from 'react';
import Modal from 'react-responsive-modal';
import { Button } from 'src/components/Buttons/Button';
import { IReport } from 'src/models/report';
import { IAsyncState } from 'src/state/action';
import 'src/style/components/reportSaveModal.scss';

const modalCssClasses = {
  overlay: 'rb-modal-overlay',
  modal: 'rb-modal rb-report-save-modal',
  closeButton: 'rb-close-button',
};

// #region -------------- Interfaces -------------------------------------------------------------------

interface IProps {
  title: string;
  status: IAsyncState<IReport>;
  report: IReport;
  isOpen: boolean;
  onCloseCallback: () => void;
  onSaveCallback: () => void;
  onChangeCallback: (title: string) => void;
}

// #endregion

// #region -------------- Component -------------------------------------------------------------------

export class ReportSaveModal extends React.PureComponent<IProps> {
  public render() {
    const { isOpen, title, report, onCloseCallback, onSaveCallback } = this.props;

    return (
      <Modal
        classNames={modalCssClasses}
        open={isOpen}
        onClose={onCloseCallback}
        closeIconSize={20}
        animationDuration={300}
        center
      >
        <div className='rb-title-dark rb-title-medium'>
          {report ? 'Update Report' : 'Save Report'}
        </div>

        {this.renderError()}

        <div>
          <label>Report title</label>
          <input value={title} onChange={this.onChange} />
        </div>

        <div className='rb-btn-container'>
          <Button
            title={report ? 'Update' : 'Save'}
            styleClasses='rb-btn-small rb-btn-crimson'
            onClick={onSaveCallback}
          />
        </div>
      </Modal>
    );
  }

  private renderError = () => {
    const { status } = this.props;

    if (!status || !status.error) {
      return null;
    }

    return <div className='alert alert-danger' > {status.error} </div>;
  }

  private onChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.props.onChangeCallback(event.target.value);
  }
}

// #endregion
